import Rails from "@rails/ujs";
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit() {
    // Prefer the native form submit (works without rails-ujs and respects
    // HTML validation); fall back to rails-ujs for older browsers.
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit();
    } else {
      Rails.fire(this.element, 'submit');
    }
  }
}
